<mat-card class="card-linnks margin-linnks">
  <mat-card-title>
    {{title}}
    <mat-card-subtitle>
      {{subtitle}}
    </mat-card-subtitle>
  </mat-card-title>

  <div class="ui-g">
    <div class="ui-g-12">
      <div class="ui-g-12">

      </div>
    </div>
  </div>

  <mat-card-content>
    <div *ngIf="!novaConta && !editarConta">
      <div class="row">
        <div class="col-sm-12">

          <div class="header-box">
            <div class="header-box-content p-4">
              <div class="actions-card">
                <app-toolbar [value]="toolbarMain"></app-toolbar>
              </div>
            </div>
          </div>

          <div class="box-content p-3">
            <p-table class="table-system" #dt [columns]="this['columns']" [value]="registrosTipoDocumento" [rows]="rows"
              [paginator]="true" [pageLinks]="pageLinks" [rowsPerPageOptions]="rowsPerPage" [style]="{'width':'100%'}"
              immutable="false" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [(selection)]="select"
              selectionMode="multiple">
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center" style="width: 40px;">
                  </th>
                  <th class="text-left">
                    <span class="overflow-ellipse text-left" [pSortableColumn]="'cod'">
                      Cod <p-sortIcon [field]="'cod'"></p-sortIcon>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'cod', 'contains')">
                  </th>

                  <th class="text-left">
                    <span class="overflow-ellipse text-left" [pSortableColumn]="'descricao'">
                      Descrição <p-sortIcon [field]="'descricao'"></p-sortIcon>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'descricao', 'contains')">
                  </th>

                  <th class="text-left">
                    <span class="overflow-ellipse text-left" [pSortableColumn]="'tipoArquivo.nome'">
                      Tipo Arquivo <p-sortIcon [field]="'tipoArquivo.nome'"></p-sortIcon>
                    </span>
                    <input class="form-control form-control-sm" type="text"
                      (input)="dt.filter($event.target.value, 'tipoArquivo.nome', 'contains')">
                  </th>
              </ng-template>

              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td class="text-center" style="width: 40px;">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                  </td>

                  <td class="text-left">
                    <span class="text-overflow-dynamic-container">
                      <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.cod}}">
                        {{rowData.cod}}
                      </span>
                    </span>
                  </td>

                  <td class="text-left">
                    <span class="text-overflow-dynamic-container">
                      <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.descricao}}">
                        {{rowData.descricao}}
                      </span>
                    </span>
                  </td>

                  <td class="text-left">
                    <span class="text-overflow-dynamic-container">
                      <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.tipoArquivo?.nome}}">
                        {{rowData.tipoArquivo?.nome}}
                      </span>
                    </span>
                  </td>

                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-rowData>
                <tr>
                  <td [attr.colspan]="4" class="spaced-alert">
                    <div class="alert alert-xs alert-primary d-inline" role="alert">
                      <i class="fas fa-info-circle"></i> Nenhum registro encontrado!
                    </div>
                  </td>
                </tr>
              </ng-template>

            </p-table>
          </div>

        </div>
      </div>
    </div>


    <div class="row form-projeto" *ngIf="novaConta || editarConta">
      <div class="col-sm-6" style="min-width: 818px;">
        <div class="header-box">
          <div class="header-box-content p-4">
            <div class="actions-card">
              <app-toolbar [value]="toolbarMain"></app-toolbar>
            </div>
          </div>
        </div>

        <div class="box-content">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Cod<span class="obrigatorio">*</span></label>
              <input class="form-control" id="input" type="text" pInputText name="cod" [(ngModel)]="cod">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Descrição<span class="obrigatorio">*</span></label>
              <input class="form-control" id="input" type="text" pInputText name="descricao" [(ngModel)]="descricao">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>Tipo Arquivo<span class="obrigatorio">*</span></label>
              <p-dropdown class="type-p-dropdown" placeholder="Selecione" [options]="tipoArquivo"
                [(ngModel)]="selectedTipoArquivo" optionLabel="nome" optionValue="id">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>